import { Component,
  Input,
  Output,
  OnInit,
  OnChanges,
  SimpleChanges,
  EventEmitter } from '@angular/core';

import { DropdownMenuOption } from 'app/models/dropdown-menu-option';
import { File } from 'app/models/file';
import { Storyboard } from 'app/models/storyboard';
import { FileSizePipe } from 'app/shared/pipes/file-size.pipe';

@Component({
  selector: 'app-storyboard-header',
  templateUrl: './storyboard-header.component.html',
  styleUrls: ['./storyboard-header.component.scss'],
  providers: [FileSizePipe]
})
export class StoryboardHeaderComponent implements OnInit, OnChanges {
  @Input() storyboard: Storyboard;
  @Output() change: EventEmitter<File> = new EventEmitter();
  fileSelected: number;
  options: Array<DropdownMenuOption>;

  constructor(private fileSizePipe: FileSizePipe) {}

  changeFile(direction): void {
    switch (direction) {
      case 'previous':
        if (this.fileSelected > 0) {
          --this.fileSelected;
        }
        break;
      case 'next':
        if (this.fileSelected < this.storyboard.files.length - 1) {
          ++this.fileSelected;
        }
        break;
    }

    this.change.emit(this.storyboard.files[this.fileSelected]);
  }

  ngOnChanges(allChanges: SimpleChanges) {
    if (allChanges.storyboard.currentValue) {
       this.options = [
        new DropdownMenuOption('1',
        'Download Set ('
          + this.fileSizePipe.transform(allChanges.storyboard.currentValue.size, 'MB') + ')'),
        new DropdownMenuOption('2', 'Share Set'),
        new DropdownMenuOption('3', 'Ask Question About Set')
      ];
    }
  }

  ngOnInit() {
    this.fileSelected = 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/storyboard-header/storyboard-header.component.ts